import { ComponentType, SVGProps } from "react";

import { IconDeliveryPickUpViewInspect } from "@/assets/icons/figma/IconDeliveryPickUpViewInspect";
import { IconDeliveryShippingBoxCustom } from "@/assets/icons/figma/IconDeliveryShippingBoxCustom";
import { IconDeliveryWhoppahCourierOutline } from "@/assets/icons/figma/IconDeliveryWhoppahCourierOutline";
import { IconMediaChatOutine } from "@/assets/icons/figma/IconMediaChatOutine";
import { IconMediaFileList } from "@/assets/icons/figma/IconMediaFileList";
import { IconMediaMailOutline } from "@/assets/icons/figma/IconMediaMailOutline";
import { IconNavigationArrowReturn } from "@/assets/icons/figma/IconNavigationArrowReturn";
import { IconProfilePersonalProfileOutline } from "@/assets/icons/figma/IconProfilePersonalProfileOutline";
import { IconStateQuestionTooltipOutline } from "@/assets/icons/figma/IconStateQuestionTooltipOutline";
import { IconThemeArt } from "@/assets/icons/figma/IconThemeArt";
import { IconThemeBidding } from "@/assets/icons/figma/IconThemeBidding";
import { IconThemeCreditCard } from "@/assets/icons/figma/IconThemeCreditCard";
import { IconThemeCustomerSupport } from "@/assets/icons/figma/IconThemeCustomerSupport";
import { IconThemeGallery } from "@/assets/icons/figma/IconThemeGallery";
import { IconThemeShop } from "@/assets/icons/figma/IconThemeShop";
import { IconThemeSwatches } from "@/assets/icons/figma/IconThemeSwatches";

export const HELP_REVALIDATE_SECONDS = 600;

export const HELP_SEARCH_DEBOUNCE_MS = 250;

export const HELP_SEARCH_MIN_LENGTH = 2;

export const HELP_FEEDBACK_MAX_COMMENT = 2000;

export const HELP_FEATURED_LIMIT = 8;

export const HELP_POPULAR_CHIP_LIMIT = 6;

export const HELP_RELATED_LIMIT = 4;

export const HELP_CATEGORY_PREVIEW_ARTICLES = 3;

export const HELP_SUPPORT_EMAIL = "support@whoppah.com";

export const HELP_SEO_TITLE_MAX = 70;

type HelpIcon = ComponentType<SVGProps<SVGSVGElement>>;

/**
 * Stable icons keyed by help-service category id. Unknown ids fall through to
 * the slug map, then to a generic icon.
 */
export const HELP_CATEGORY_ICON_BY_ID: Record<string, HelpIcon> = {};

export const HELP_CATEGORY_ICON_BY_SLUG: Record<string, HelpIcon> = {
  "my-account": IconProfilePersonalProfileOutline,
  "transport-courier": IconDeliveryWhoppahCourierOutline,
  returns: IconNavigationArrowReturn,
  return: IconNavigationArrowReturn,
  curation: IconThemeSwatches,
  "curation-rules": IconThemeSwatches,
  "payments-and-payouts": IconThemeCreditCard,
  bidding: IconThemeBidding,
  "bidding-process": IconThemeBidding,
  "custom-delivery": IconDeliveryShippingBoxCustom,
  "view-and-pick-up": IconDeliveryPickUpViewInspect,
  "pick-up": IconDeliveryPickUpViewInspect,
  listing: IconMediaFileList,
  "selling-on-whoppah": IconThemeShop,
  "general-questions-about-selling": IconThemeShop,
  "buying-on-whoppah": IconThemeShop,
  "frequently-asked-questions-about-buying-on-whoppah": IconThemeShop,
  contact: IconThemeCustomerSupport,
  "communication-with-buyer-or-seller": IconMediaChatOutine,
  showroom: IconThemeGallery,
  "showmodellen-x-whoppah": IconThemeGallery,
  "selling-art-on-whoppah": IconThemeArt,
  "send-and-receive-by-post": IconDeliveryWhoppahCourierOutline,
};

export const getHelpCategoryIcon = (category: {
  id: string;
  slug: string;
}): HelpIcon =>
  HELP_CATEGORY_ICON_BY_ID[category.id] ??
  HELP_CATEGORY_ICON_BY_SLUG[category.slug] ??
  IconStateQuestionTooltipOutline;

export const HelpFallbackCategoryIcon = IconStateQuestionTooltipOutline;

export const HelpContactIcon = IconThemeCustomerSupport;

export const HelpMailIcon = IconMediaMailOutline;
